import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminStartups from "./pages/AdminStartups";
import AdminSponsors from "./pages/AdminSponsors";
import AdminJudges from "./pages/AdminJudges";
import AdminPodcast from "./pages/AdminPodcast";
import AdminApplications from "./pages/AdminApplications";
import AdminAirtableSync from "./pages/AdminAirtableSync";
import AdminSlideshows from "./pages/AdminSlideshows";
import AdminDecisionMakers from "./pages/AdminDecisionMakers";
import SlideshowEditor from "./pages/SlideshowEditor";
import ReviewSlideEditor from "./pages/ReviewSlideEditor";
import Sponsors from "./pages/Sponsors";
import Podcast from "./pages/Podcast";
import Buyers from "./pages/Buyers";
import StartupsPage from "./pages/StartupsPage";
import StartupProductPage from "./pages/StartupProductPage";
import BuyerPitches from "./pages/BuyerPitches";
import BuyerPitchSession from "./pages/BuyerPitchSession";
import BuyerPitchPaymentSuccess from "./pages/BuyerPitchPaymentSuccess";
import CyberSponsor from "./pages/CyberSponsor";

// Handle session_id from URL fragment BEFORE ProtectedRoute runs
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (synchronous - prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/buyers" element={<Buyers />} />
      <Route path="/sponsors" element={<Sponsors />} />
      <Route path="/sponsor/cyber" element={<CyberSponsor />} />
      <Route path="/podcast" element={<Podcast />} />
      <Route path="/startups" element={<StartupsPage />} />
      <Route path="/startups/:slug" element={<StartupProductPage />} />
      <Route path="/buyer-pitches" element={<BuyerPitches />} />
      <Route path="/buyer-pitches/payment-success" element={<BuyerPitchPaymentSuccess />} />
      <Route path="/buyer-pitches/:slug" element={<BuyerPitchSession />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/testimonials" element={<AdminTestimonials />} />
      <Route path="/admin/startups" element={<AdminStartups />} />
      <Route path="/admin/sponsors" element={<AdminSponsors />} />
      <Route path="/admin/judges" element={<AdminJudges />} />
      <Route path="/admin/decision-makers" element={<AdminDecisionMakers />} />
      <Route path="/admin/podcast" element={<AdminPodcast />} />
      <Route path="/admin/applications" element={<AdminApplications />} />
      <Route path="/admin/airtable-sync" element={<AdminAirtableSync />} />
      <Route path="/admin/slideshows" element={<AdminSlideshows />} />
      <Route path="/admin/slideshows/:id" element={<SlideshowEditor />} />
      <Route path="/admin/slideshows/:id/slides/:slideId" element={<ReviewSlideEditor />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
